import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import MenuItem from "@mui/material/MenuItem";
import { Toolbar, IconButton, Typography, Menu, Tooltip } from "@mui/material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { useNavigate } from "react-router-dom";
import useAuth from "../../partials/hooks/useAuth";
import { useSelector } from "react-redux";
import { selectUser } from "../../state/settings/settingsSelectors";
import { RootState, useAppDispatch } from "../../state/store";
import { resetSettings } from "../../state/settings/settingsSlice";
import { useMemo } from "react";
import { useHeaderStyles } from "./Header.styles";

const settings = ["Logout"];

const Header = (): JSX.Element => {
  const sx = useHeaderStyles();
  const navigate = useNavigate();
  const auth = useAuth();
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const user = useSelector((state: RootState) => selectUser(state));
  const dispatch = useAppDispatch();

  const userLetter = useMemo(() => {
    if (user?.nickname) {
      return user.nickname[0];
    }
    if (user?.email) {
      return user.email[0];
    }
    return "A";
  }, [user]);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>): void => {
    // Todo: update to menu items later
    if (auth !== null && auth !== undefined && auth) {
      setAnchorElUser(event.currentTarget);
      return;
    }
    navigate("/login");
  };

  const handleCloseUserMenu = (setting: string): void => {
    setAnchorElUser(null);
    if (setting === "Logout") {
      localStorage.removeItem("authToken");
      sessionStorage.removeItem("accessToken");
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("tenantId");
      sessionStorage.removeItem("isAdmin");
      sessionStorage.removeItem("isRfidAllowed");
      // @ts-ignore
      dispatch(resetSettings());
      navigate("/login");
    }
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "#ffffff !important"
      }}>
      <Toolbar
        disableGutters
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0 20px"
        }}>
        <Typography variant="h6" noWrap component="a" href="#" sx={{ ...sx.appBarTitle, display: { xs: "none", md: "flex" } }}>
          Scodix Password Generator
        </Typography>
        <Box
          sx={{
            flexGrow: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
          <Tooltip title="Settings">
            <Typography variant="body1" sx={{ cursor: "pointer" }}>
            </Typography>
          </Tooltip>
          <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
            <Avatar alt={user?.nickname ?? ""} src="/static/images/avatar/2.jpg">
              {userLetter.toUpperCase()}
            </Avatar>
          </IconButton>
          <Menu
            sx={{ mt: "45px" }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}>
            {settings.map((setting) => (
              <MenuItem key={setting} onClick={() => handleCloseUserMenu(setting)}>
                <Typography textAlign="center">{setting}</Typography>
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
